import { filter } from 'rxjs/operators';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, NavController } from '@ionic/angular';
//import { Options, QRCode } from 'ngx-qrcode-styling';
import { Storage } from '@ionic/storage';
import { CodebaseTranslateService } from '@app/services/codebase-translate.service';
import { MyroomComponent } from '@app/codebase/checkin/myroom/myroom.component';
import { UsersApiService } from '@app/core/users-api/users-api.service';
import { LoadingService } from '@app/shared/services/loading.service';
import { GenericAlertComponent } from '@app/shared/generic-alert/generic-alert.component';
import { environment } from '@env/environment';
import moment from 'moment';
import { CloudbedsService } from '@app/services/cloudbeds.service';
import { PopupPrearrivalComponent } from '../popup-prearrival/popup-prearrival.component';
import { PopupMessageComponent } from "../popup-message/popup-message.component";

@Component({
  selector: "app-qrcode",
  templateUrl: "./qrcode.page.html",
  styleUrls: ["./qrcode.page.scss"],
})
export class QrcodePage implements OnInit {
  @Input() reservation: any = null;
  @Input() translates: any;
  title = 'app';
  elementType = 'object';
  today = moment().format('LL')
  tomorrow = moment().add(1, 'day').format('LL')
  public qrCodeValue: any = null;
  public changeValue : boolean = false;
  public showhome : boolean = false;
  public environment = environment;
  public config: any = null;
  // public config: Options = {
  //   width: 350,
  //   height: 350,
  //   data: "",
  //   // image: "assets/icons/logo-connect.png",
  //   margin: 5,
  //   rotate: 100,
  //   dotsOptions: {
  //     color: "#000000",
  //     // type: "rounded"
  //   },
  //   backgroundOptions: {
  //     color: "#ffffff",
  //   },
  //   imageOptions: {
  //     crossOrigin: "anonymous",
  //     margin: 5
  //   },
  //   cornersSquareOptions: {
  //     color: "#000000",
  //     // type: "extra-rounded"
  //   },
  //   cornersDotOptions: {
  //     color: "#000000",
  //     // type: "dot"

  //   }
  // };
  qrcodeparam: any;
  constructor(
    private router: Router,
    private storage: Storage,
    private route: ActivatedRoute,
    private navCtrl: NavController,
    private loading: LoadingService,
    public usersApi: UsersApiService,
    public cloudbedService: CloudbedsService,
    public translate: CodebaseTranslateService,
    private modalCtrlr: ModalController,) {}

  async ngOnInit() {
    this.route.queryParams.subscribe(async params => {
      console.log(params)
      this.qrcodeparam = params.qr;
      var ctrl=this;
      if (params.reservationId){
        this.qrCodeValue = {
          reservationId: params.reservationId
        }
        console.log(this.qrCodeValue)
        //this.config.data =  JSON.stringify(this.qrCodeValue);
        this.changeValue = true;
        if (environment.nexi.useCloudbedsAPI){
          this.cloudbedService.findReservation({reservationId: params.reservationId}).then((resp: any) => {
            if (resp && resp[0].data){
              if (this.reservation.reservationID != resp[0].data.reservationID || !this.reservation.assigned[0].keyCode ) {
                this.reservation = resp[0].data;
                var myRes = this.reservation;
                var roomID = this.reservation.assigned[0].roomID;
                this.cloudbedService.getRooms().then((resp: any) => {
                  if (resp){
                    var rooms = resp.data[0].rooms;
                    rooms.forEach(function (room) {
                        if (room.roomID && room.roomID.toString() == roomID) {
                            if (room.doorlockID) {
                                myRes.assigned[0].keyCode = room.doorlockID.split('');
                            }
                            else {
                                myRes.assigned[0].keyCode = '0000'.split('');
                            }
                            ctrl.storage.set("reservationData", myRes);
                            return;
                        }
                    });
                  }
                })
              }
            }
          })
          return;
        }else{
          const reservation = await this.storage.get("reservationValue");
          console.log(this.reservation)
          this.qrCodeValue = {
            reservationId: reservation
          }
          console.log(this.qrCodeValue)
          //this.config.data =  JSON.stringify(this.qrCodeValue)
          this.changeValue = true;
          this.tomorrow = moment().add(1, 'day').format('LL')
          return;
        }
      }
      // if (environment.demoMode){
      //   // this.qrCodeValue = {
      //   //   reservationId: '1781709293016'
      //   // }
      //   if (!this.reservation) this.reservation = await this.storage.get("reservationData");
      //   console.log(this.reservation)
      //   this.qrCodeValue = {
      //     reservationId: this.reservation.reservationID
      //   }
      //   console.log(this.qrCodeValue)
      //   this.config.data =  JSON.stringify(this.qrCodeValue)
      //   this.changeValue = true;
      //   this.tomorrow = moment(this.reservation.endDate).format('LL')
      //   return;

      // }
    })
    // console.log(this.r)
  }

  async getData(){
    await this.loading.presentLoading()
    this.qrCodeValue = null;
    let rooms = null;
    if (this.reservation.assigned.find(item => item.Selected)){
      rooms = this.reservation.assigned.filter(item => item.Selected).map(item => item.roomName);
    }else{
      rooms = this.reservation.assigned.map(item => item.roomName);
    }
    this.qrCodeValue = {
      reservationId: '1781709293016'
    }
    console.log(this.qrCodeValue)
    // this.qrCode.addData(this.qrCodeValue)
    //this.config.data = JSON.stringify(this.qrCodeValue)
    this.changeValue = false;
    await this.loading.dismiss()
  }

  async chooseRoom(idx){
    this.changeValue = true;
    this.reservation.assigned[idx].Selected = !this.reservation.assigned[idx].Selected;
    this.getData()
  }

  openRoomManager(){
    this.router.navigate(['/welcome-checkin/room-manager'], {queryParams: {roomManager: true}});
  }
  async ionViewDidEnter(){
    if (!this.reservation) this.reservation = await this.storage.get("reservationData");
    //this.ngOnInit();
    console.log("ionViewDidEnter")
  }

  async onUserTap() {
    const test = await this.usersApi
      .isLoggedIn();

    console.log(test)
      // .then((loggedIn) => {
        if (test) {
          this.router.navigateByUrl(`/tabs/me`, {
            relativeTo: this.route,
          });
        } else {
          this.showLoginAlert();
        }
      // })
      // .catch((err) => {
      //   // error, not sure what to do here but let's show a login alert page
      //   this.showLoginAlert();
      // });
  }

  goBack(){
    if (this.showhome) {
      this.showhome = false;
      this.router.navigate(['/tabs/home']);
    }
    else {
      window.history.back();
    }
  }

  checkin(){
    this.router.navigate(['/checkin/prearrival'], {queryParams: {isCheckin: true}})
  }
  getKey() {

  }
  async showUpgrade(){
    const modal = await this.modalCtrlr.create({
          cssClass: 'popuparrival-modal-upgrade',
          component:  PopupPrearrivalComponent,
          componentProps: {
            title: `Welcome to NEXI, ${this.reservation.guestName}`,
            text: `<b>You can upgrade your stay</b>`,
            reservationNumber: this.reservation.reservationID,
            upgrade: true,
            buttons: [
              {
                title: 'Close',
                value: 'close'
              }
            ]
          }
        });
        await modal.present();
        const { data } = await modal.onDidDismiss();
        if (data && data.value == 'checkin') {
          this.router.navigate(['/checkin/prearrival'], {queryParams: {isCheckin: true}})
        }
  }
  async showLoginAlert() {
    //this.translate.languageChange(this.homePage.languageSelected.val);
    const modal = await this.modalCtrlr.create({
      cssClass: "generic-alert-modal",
      component: GenericAlertComponent,
      componentProps: {
        title: this.translate.instant("MODAL_LOGIN.TITLE"),
        message: this.translate.instant("MODAL_LOGIN.SUBTITLE"),
        buttons: [
          {
            title: this.translate.instant("MODAL_LOGIN.BTN_LOGIN"),
            value: "login",
          },
          {
            title: this.translate.instant("MODAL_LOGIN.BTN_CANCEL"),
            value: "cancel",
          },
        ],
      },
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    if (data && data.value === "login") {
      return this.navCtrl.navigateRoot(["/login"], {
        queryParams: { redirectUrl: this.router.url },
      });
    } else {
      return "";
    }
  }

  clickCheckOut(){
    // this.modalCtrlr.dismiss();
    this.router.navigate(['/tabs/checkout']);

  }

  gotoHelp(){
    // this.modalCtrlr.dismiss();
    this.router.navigate(['/tabs/help'], {queryParams: {showInstructions: true}});
  }
  async showRoom() {
    if (environment.nexi.useCode) {
      const modal = await this.modalCtrlr.create({
        cssClass: 'popup-modal-map',
        component:  PopupMessageComponent,
        componentProps: {
          title: 'Property Map',
          image: 'themes/' + environment.theme.name + '/assets/Hotel-Map.png',
          showList: false,
          buttons: [
            {
              title: 'Done',
              value: 'skip'
            }
          ]
        }
      });
      await modal.present();
      const { data } = await modal.onDidDismiss();
    }
    else {
      if (environment.demoMode){
        this.router.navigate([`/tabs/myroom/206`]);
      }else{
        this.router.navigate([`/tabs/myroom/${this.reservation.assigned.find(item => item.Selected) ? this.reservation.assigned.find(item => item.Selected).roomName : this.reservation.assigned[0].roomName}`]);
      }
    }
  }

}
